import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";

import { IBillDetail } from "../../BillTypes";
import { useDetailModel } from "@/views/account/internal/detailModel";
import { useBillInternalModel } from "../billInternalModel";
import useGlobalModel from "@/model/globalModel";
import { billStatusRender } from "@/types/FmsRender";



export function BillDataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useBillInternalModel();

    const {
        payMethodLabels,
    } = useDetailModel()
    const { user: { shopCode } } = useGlobalModel()


    const columns: ColumnsType<IBillDetail> = [
        {
            align: "center",
            width: 60,
            ellipsis: true,
            title: '序号',
            render: (v, r, i) => i + 1
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '调入分支',
            dataIndex: 'branchIn',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '调出分支',
            dataIndex: 'branchOut',
        },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: '调拨单号',
            dataIndex: 'code',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '交易方向',
            dataIndex: 'shopCode',
            render: (v, r) => v === shopCode ? '调入' : '调出'
        },

        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '单据金额',
            dataIndex: 'aggregateAmount',
        },
        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '调入账户',
        //     dataIndex: '',
        // },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: '调入门店',
            dataIndex: 'shopName',
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '调入实体',
            dataIndex: 'bentityName',
        },
        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '调出账户',
        //     dataIndex: '',
        // },
        {
            align: "center",
            width: 200,
            ellipsis: true,
            title: '调出门店',
            dataIndex: 'outShopName',
        },
        {
            align: "center",
            width: 300,
            ellipsis: true,
            title: '调出实体',
            dataIndex: 'outBentityName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '调拨类型',
            dataIndex: 'transferTypeName',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '账单状态',
            dataIndex: 'status',
            render: billStatusRender
        },
        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '结款状态',
        //     dataIndex: 'payStatus',
        //     render: billStatusRender
        // },
        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '支付类型',
        //     dataIndex: 'payType',
        //     render: v => payMethodLabels[v]
        // },

        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '记账日期',
            dataIndex: 'createTime',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '核销人',
            dataIndex: 'writeoffUser',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '核销日期',
            dataIndex: 'writeoffTime',
        },

        // {
        //     align: "center",
        // width: 100,
        // ellipsis: true,
        //     title: '单据编码',
        //     dataIndex: 'code',
        // },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '业务员',
            dataIndex: 'createUser',
        },
        {
            align: "center",
            width: 100,
            ellipsis: true,
            title: '备注',
            dataIndex: 'note',
        },
    ];


    return (
        <Table
            // rowSelection={{
            //     type: "radio",
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IBillDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys);
            //     },
            //     selectedRowKeys
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
        // onRow={record => {
        //     return {
        //         onClick: event => {
        //             if (selectedRowKeys.length > 0 && selectedRowKeys[0] === record.key) {
        //                 setSelectedRowKeys([]);
        //             } else {
        //                 setSelectedRowKeys([record.key]);
        //             }
        //         },
        //     };
        // }}
        />
    )
}
